// 'use strict';

import $ from 'jquery';

class DevelopmentsNav {

  constructor() {
    this.$el = $('.developments-nav');
    this.events(this.$el);
  }

  events($el) {
    $('a', $el).on('click', (e) => {
      // e.preventDefault(); // Removed so that normal links still works

      let url = e.target.href;
      let scrollTo = e.target.hasAttribute('data-scroll-to');

      if (url && scrollTo) {
        this.goToDevelopment(url);
      }

      // active states
      $('a', $el).removeClass('active');
      $(e.currentTarget).addClass('active');

      if(this.isTouchDevice()) {
        $('ol', $el).hide();
      }
    });

    if(this.isTouchDevice()) {
      $('a.developments-nav-title').unbind();
      $('a.developments-nav-title').on('click', (e) => {
        e.preventDefault();
        $('ol', $el).removeAttr('style');
      });
    }
  }

  goToDevelopment(url) {
    if (typeof history === 'object' && typeof history.pushState === 'function') {
      history.pushState(null, '', url);
      // scroll to is handled using the new/Navigation class
    } else {
      window.location = url;
    }
  }

  isTouchDevice () {
    return 'ontouchstart' in window        // works on most browsers
      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  }

}

export { DevelopmentsNav as default };
